/** English chrome strings. Sentence case; no em dashes (DESIGN voice rules). */
const en = {
  app: {
    title: 'Pharadev Admin',
    edition: 'Bilingual websites & business software',
    primaryNav: 'Primary',
    toggleNav: 'Toggle navigation',
    version: 'Version',
  },
  nav: {
    dashboard: 'Dashboard',
    content: 'Content',
    pages: 'Pages',
    fieldNotes: 'Blog',
    services: 'Services',
    caseStudies: 'Case studies',
    packages: 'Packages',
    clients: 'Clients',
    testimonials: 'Testimonials',
    productFamilies: 'Product families',
    industries: 'Industries',
    projects: 'Projects',
    articles: 'Articles',
    jobPostings: 'Job postings',
    products: 'Products',
    locations: 'Locations',
    subsidiaries: 'Subsidiaries',
    siteAssets: 'Site assets',
    teamMembers: 'Team members',
    media: 'Media library',
    leads: 'Leads',
    contact: 'Discovery calls',
    quotes: 'Quote requests',
    applications: 'Job applications',
    newsletter: 'Newsletter',
    revisions: 'Revisions',
    administration: 'Administration',
    users: 'Users',
    apiTokens: 'API tokens',
    settings: 'Site settings',
    audit: 'Audit log',
    search: 'Search',
    account: 'Account',
    signOut: 'Sign out',
  },
  common: {
    save: 'Save',
    saveDraft: 'Save draft',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    confirm: 'Confirm',
    ok: 'OK',
    retry: 'Retry',
    reset: 'Reset',
    publish: 'Publish',
    unpublish: 'Unpublish',
    schedule: 'Schedule',
    preview: 'Preview',
    status: 'Status',
    title: 'Title',
    slug: 'Slug',
    key: 'Key',
    namespaces: 'Namespaces',
    updated: 'Updated',
    created: 'Created',
    actions: 'Actions',
    loading: 'Loading',
    search: 'Search',
    filters: 'Filters',
    clear: 'Clear',
    copy: 'Copy',
    all: 'All',
    none: 'None',
    en: 'English',
    ar: 'Arabic',
    lastSaved: 'Last saved {{time}}',
    siteWillUpdate: 'Saved. The public site will update shortly.',
    permissionDenied: "You don't have permission to do that.",
    missingArabic: 'AR incomplete',
    arComplete: 'AR complete',
  },
  auth: {
    signIn: 'Sign in',
    email: 'Email',
    password: 'Password',
    totp: 'Authentication code',
    totpHint: 'Enter the 6-digit code from your authenticator app.',
    forgot: 'Forgot password?',
    forgotTitle: 'Reset your password',
    forgotNeutral: 'If an account exists for that email, you will receive reset instructions.',
    resetTitle: 'Choose a new password',
    newPassword: 'New password',
    locked: 'This account is temporarily locked. Try again later.',
    rateLimited: 'Too many attempts. Please wait a moment and try again.',
    invalid: 'Email or password is incorrect.',
    invalidTotp: 'That authentication code is incorrect. Try again.',
    totpRequired: 'Enter the 6-digit code from your authenticator app to continue.',
    eyebrowSignIn: 'Admin · Sign in',
    eyebrowReset: 'Admin · Reset',
    sendResetLink: 'Send reset link',
    resetInvalid: 'That reset link is invalid or has expired. Request a new one.',
    setNewPassword: 'Set new password',
  },
  ui: {
    nothingHereYet: 'Nothing here yet',
    noResults: 'No results',
    somethingWentWrong: 'Something went wrong.',
    error: 'Error',
    reportThis: 'Report this',
    readOnlyAccess: 'You have read-only access to this area.',
    paginationSummary: '<from>{{from}}</from>–<to>{{to}}</to> of <total>{{total}}</total>',
    perPage: 'Per page',
    prev: 'Prev',
    next: 'Next',
    previousPage: 'Previous page',
    nextPage: 'Next page',
    close: 'Close',
    typeToConfirm: 'Type "{{phrase}}" to confirm',
    selectPlaceholder: 'Select…',
    selectAllRows: 'Select all rows',
    selectRow: 'Select row {{id}}',
    crashTitle: 'This view ran into a problem',
    crashBody: 'The rest of the console is unaffected. Try again, or reload the page.',
    reload: 'Reload',
  },
  status: {
    content: {
      draft: 'Draft',
      in_review: 'In review',
      scheduled: 'Scheduled',
      published: 'Published',
      archived: 'Archived',
    },
    lead: {
      new: 'New',
      in_progress: 'In progress',
      reviewing: 'Reviewing',
      shortlisted: 'Shortlisted',
      responded: 'Responded',
      hired: 'Hired',
      rejected: 'Rejected',
      closed: 'Closed',
      spam: 'Spam',
      archived: 'Archived',
    },
    newsletter: {
      confirmed: 'Confirmed',
      pending_confirmation: 'Pending',
      unsubscribed: 'Unsubscribed',
    },
  },
  forms: {
    remove: 'Remove',
    addItem: '+ Add item',
    addEntry: '+ Add entry',
    mapKey: 'Key',
    mapValue: 'Value',
    mapKeyDuplicate: 'Duplicate key',
    item: 'Item {{n}}',
    indexLabel: '#{{n}}',
    rawHint: 'Raw JSON fallback. Validated on save.',
    rawLabel: '{{name}} (raw)',
    choose: 'Choose',
    noMediaSelected: 'No media selected',
    noEntitySelected: 'No {{collection}} reference selected',
    fieldEnglish: '{{label}} (English)',
    fieldArabic: '{{label}} (Arabic)',
    refNone: 'None selected',
    refMissing: '{{value}} (not found)',
    noFields: 'No configurable fields.',
  },
  governance: {
    arCoverage: 'Arabic coverage',
    noTranslatableFields: 'No translatable text yet',
    coverageCount: '{{translated}} / {{total}} translated',
    arabicComplete: 'Arabic translation is complete',
    arabicCompleteHintReady: 'All translatable fields have Arabic text.',
    arabicCompleteHintPending: '{{count}} field(s) still missing Arabic.',
    arabicCompleteGate: 'Until this is on, publishing may be blocked to avoid serving a half-translated page.',
    publishBlockedAr: "Can't publish: Arabic copy is incomplete.",
    publishBlockedArDetail: 'Finish the Arabic translation and mark "Arabic translation is complete", then publish.',
  },
  vocab: {
    block: {
      paragraph: 'Paragraph',
      subheading: 'Subheading',
      list: 'List',
      pullquote: 'Pull quote',
      aside: 'Aside',
      figure: 'Figure',
    },
    packageCategory: {
      none: 'No product (add-ons and care plans)',
      website: 'Website',
      app: 'App',
      service: 'Service',
    },
    packageKind: {
      project: 'Project',
      addon: 'Add-on',
      care: 'Care plan',
      audit: 'Audit',
    },
    priceUnit: {
      project: 'Per project',
      month: 'Per month',
      each: 'Each',
      percent: 'Percent of the project',
    },
    estimatorRole: {
      none: 'Not in the estimator',
      integration: 'Integrations (count)',
      mobileApp: 'Mobile app',
      inheritedCode: 'Code another team wrote',
      liveReplacement: 'Replacing a live site',
    },
    clientType: {
      external: 'External',
      group: 'Group brand',
    },
    department: {
      leadership: 'Leadership',
      marketing: 'Marketing',
      engineering: 'Engineering',
    },
    topic: {
      automation: 'Automation',
      digitalTransformation: 'Digital transformation',
      ai: 'AI',
      customSoftware: 'Custom software',
      integration: 'Integration',
      security: 'Security',
    },
    icon: {
      zap: 'Zap',
      code: 'Code',
      puzzle: 'Puzzle',
      brain: 'Brain',
      shield: 'Shield',
      clipboardCheck: 'Clipboard check',
      search: 'Search',
    },
    industry: {
      restaurant: 'Restaurant',
      mobile: 'Mobile',
      aiSaas: 'AI SaaS',
      publishing: 'Publishing',
      industrial: 'Industrial',
      education: 'Education',
    },
    device: {
      laptop: 'Laptop',
      phone: 'Phone',
    },
    kind: {
      product: 'Product',
      client: 'Client work',
    },
    serviceTier: {
      core: 'Core offering',
      additional: 'Also available',
    },
  },
  dashboard: {
    eyebrow: 'DASHBOARD',
    title: 'Operational overview',
    pages: 'Pages',
    contentByCollection: 'Content by collection',
    leads: 'Leads',
    agentActivity: 'Recent agent activity',
    agentActivityHint:
      'Writes made through an API token. Everything an agent creates is a draft; review it before publishing.',
    agentActivityLink: 'Open the full audit log',
    agentActor: 'API token',
    recentActivity: 'Recent activity',
    total: 'Total',
    published: 'Published',
    draft: 'Draft',
    media: 'Media',
    newCount: '{{count}} new',
    ofPublished: '/ {{total}} published',
    totalSuffix: 'total',
    systemActor: 'system',
  },
  activity: {
    action: {
      login: 'signed in',
      logout: 'signed out',
      create: 'created',
      update: 'updated',
      delete: 'deleted',
      publish: 'published',
      unpublish: 'unpublished',
    },
    entity: {
      user: 'user',
      page: 'page',
      section: 'section',
      family: 'product family',
      product_family: 'product family',
      media: 'media asset',
      industry: 'industry',
      project: 'project',
      article: 'article',
      job: 'job posting',
      product: 'product',
      location: 'location',
      subsidiary: 'subsidiary',
      setting: 'setting',
    },
  },
  content: {
    unknownCollection: 'Unknown collection.',
    newItem: 'New item',
    newItemPermission: 'Requires permission to create or edit content.',
    order: 'Order',
    arShort: 'AR',
    missingAr: 'Missing AR',
    selected: 'selected',
    publishPermission: 'Requires publish permission.',
    deletePermission: 'Requires delete permission.',
    bulkResult: '{{action}}: {{succeeded}} succeeded, {{failed}} failed.',
    bulkPartialFail: 'Some items could not be processed. Refine and retry.',
    statusFilter: {
      all: 'All statuses',
      draft: 'Draft',
      scheduled: 'Scheduled',
      published: 'Published',
      archived: 'Archived',
    },
    newTitle: 'New {{label}}',
    untitled: '(untitled)',
    editPermission: 'Requires permission to edit content.',
    slugHint: 'Auto-generated from the English title; edit to override.',
    sortOrder: 'Sort order',
    sortOrderHint: 'Lowest number first. Sets the order on the website and in this list.',
    contentTab: 'Content',
    seoTab: 'SEO',
    historyTab: 'History',
    createdToast: 'Created.',
    savedToast: 'Saved.',
    siteUpdateBody: 'The public site will update shortly.',
    publicationUpdated: 'Publication updated.',
    unpublishedToast: 'Unpublished.',
    unpublishRedirect: 'The public page now redirects to the collection index.',
    filterAll: 'All',
    choose: 'Choose {{label}}',
    deleteItemTitle: 'Delete this item?',
    deleteItemDescription: 'This item will be permanently removed. This cannot be undone.',
  },
  collections: {
    fieldNotes: { label: 'Blog', singular: 'Article' },
    services: { label: 'Services', singular: 'Service' },
    caseStudies: { label: 'Case Studies', singular: 'Case Study' },
    packages: { label: 'Packages', singular: 'Package' },
    clients: { label: 'Clients', singular: 'Client' },
    testimonials: { label: 'Testimonials', singular: 'Testimonial' },
    industries: { label: 'Industries', singular: 'Industry' },
    projects: { label: 'Projects', singular: 'Project' },
    articles: { label: 'Articles / Insights', singular: 'Article' },
    jobPostings: { label: 'Job postings', singular: 'Job posting' },
    products: { label: 'Products', singular: 'Product' },
    locations: { label: 'Locations', singular: 'Location' },
    subsidiaries: { label: 'Subsidiaries', singular: 'Subsidiary' },
    siteAssets: { label: 'Site assets', singular: 'Site asset' },
    teamMembers: { label: 'Team', singular: 'Team member' },
  },
  fields: {
    // ── Field notes (Pharadev's blog / insights collection) ────────────────
    fieldNoteContent: 'Field note',
    fieldNoteCategoryHint: 'Short kicker above the title, e.g. "On method" or "Field note".',
    excerptHint: 'One-sentence teaser shown on the blog index and in social previews.',
    readingTime: 'Reading time',
    readingTimeHint: 'Shown on the card and article, e.g. "6 min".',
    displayDate: 'Display date',
    displayDateHint: 'Human date shown to readers, e.g. "March 2026".',
    dateIso: 'Machine date',
    dateIsoHint: 'ISO date for sorting and metadata, e.g. 2026-03-14.',
    fieldNoteFeaturedHint: 'Feature this note on the index and home teaser.',
    heroSrc: 'Image path',
    heroSrcHint: 'Path or URL of the hero image (the live editor offers a media picker).',
    width: 'Width',
    height: 'Height',
    question: 'Opening question',
    questionHint: 'The question the note opens on — the Pharadev voice.',
    lede: 'Lede',
    ledeHint: 'The standfirst paragraph under the question.',
    authorName: 'Author name',
    authorRole: 'Author role',
    bodyBlock: 'Block',
    blockType: 'Type',
    blockText: 'Text',
    blockTextHint: 'Used by paragraph, subheading, pullquote and aside blocks.',
    blockItems: 'List items',
    blockAttribution: 'Attribution',
    blockAttributionHint: 'Who the pull quote is attributed to.',
    blockCaption: 'Caption',
    bodyHint: 'The essay body as ordered blocks, authored per language.',
    bodyEn: 'Body (English)',
    bodyAr: 'Body (Arabic)',
    ctaPromise: 'Promise',
    ctaSecondary: 'Secondary button',
    ctaMarginNote: 'Margin note',
    finalCta: 'Final CTA',
    finalCtaHint: 'The closing call to action, the note’s single next step.',
    finalCtaEn: 'Final CTA (English)',
    finalCtaAr: 'Final CTA (Arabic)',
    topic: 'Topic',
    topicHint: 'Optional topic chip used by the blog index filter.',
    // ── 2026 restructure collections ───────────────────────────────────────
    serviceContent: 'Service',
    caseStudyContent: 'Case study',
    packageContent: 'Package',
    clientContent: 'Client',
    testimonialContent: 'Testimonial',
    layer: 'Layer',
    layerHint: 'Where this service sits in the offer — a core service or an add-on.',
    order: 'Order',
    clientType: 'Client type',
    typeLabel: 'Type label',
    context: 'Context',
    challenge: 'Challenge',
    solution: 'Solution',
    deliverables: 'Deliverables',
    results: 'Results',
    resultPlaceholder: 'Results are placeholder',
    idealFor: 'Ideal for',
    inclusions: 'Inclusions',
    investment: 'Investment',
    recommended: 'Recommended',
    packageKind: 'Row type',
    packageKindHint: 'Projects and audits (services) are the estimator’s starting points; add-ons move a project’s price; care plans are monthly.',
    packageCategory: 'Product',
    packageCategoryHint: 'The product /pricing lists this package under. Set it on projects and audits; leave it empty on add-ons and care plans.',
    priceFrom: 'Price from (USD)',
    priceFromHint: 'Whole dollars, shown on /pricing as “from”. For a percent unit, the lowest percentage.',
    priceTo: 'Price to (USD)',
    priceToHint: 'Leave empty for no ceiling (“from $12,000”). Leads are priced on these exact figures.',
    priceUnit: 'Priced per',
    investmentHint: 'Shown under the price, e.g. “Fixed price, half up front”.',
    timeline: 'Timeline',
    recommendedHint: 'Highlights the row. Mark one per row type at most.',
    estimator: 'Estimator',
    estimatorHint: 'Projects: page and language rules. Add-ons: which estimator control this row prices.',
    estimatorRole: 'Estimator control',
    pagesIncluded: 'Pages included',
    pagesMax: 'Most pages priced',
    extraPagePrice: 'Price per extra page (USD)',
    bilingualIncluded: 'Arabic + English included',
    bilingualUpliftPct: 'Second-language uplift (%)',
    mobileIncluded: 'This package is the mobile app',
    mobileIncludedHint: 'The mobile-app add-on is not offered or charged on top of it.',
    ctaLabelField: 'Button label',
    website: 'Website',
    caseStudySlug: 'Case study slug',
    role: 'Role',
    note: 'Note',
    open: 'Open position',
    quote: 'Quote',
    company: 'Company',
    placeholder: 'Placeholder',
    testimonial: 'Testimonial',
    industry: 'Industry',
    country: 'Country',
    featured: 'Featured',
    category: 'Category',
    department: 'Department',
    graduate: 'Graduate',
    family: 'Family',
    kind: 'Kind',
    industryContent: 'Industry content',
    projectContent: 'Project content',
    articleContent: 'Article content',
    jobPostingContent: 'Job posting content',
    productContent: 'Product content',
    locationContent: 'Location content',
    isHq: 'Headquarters',
    isHqHint: 'Marks this as the head office — its card is emphasised on the contact page.',
    locationTag: 'Tag',
    locationTagHint: 'Mono kicker above the city, e.g. "Headquarters · Manufacturing".',
    address: 'Address',
    areaSqm: 'Floor area',
    areaSqmHint: 'Optional, shown as a chip, e.g. "36,000 m²".',
    phone: 'Phone',
    email: 'Email',
    hours: 'Business hours',
    here: "What's here",
    hereHint: 'Short description of the functions based at this office.',
    subsidiaryContent: 'Subsidiary content',
    subsidiaryTier: 'Tier',
    subsidiaryTierHint: 'How this entity renders on the public site: the parent brand, the KSA flagship, or a specialist subsidiary.',
    founded: 'Founded',
    foundedHint: 'Year founded, e.g. 2009.',
    subsidiaryInvestors: 'Investors page copy',
    subsidiaryAbout: 'About page copy',
    subsidiaryName: 'Display name',
    subsidiaryFunction: 'Function',
    subsidiaryCategory: 'Category',
    subsidiaryMeta: 'Meta line',
    subsidiaryBody: 'Body',
    siteAssetContent: 'Site asset',
    image: 'Image',
    imageHint: 'The image shown for this slot on the website. Replace the placeholder by uploading a real asset.',
    altText: 'Alt text',
    teamMemberContent: 'Team member',
    teamGroup: 'Group',
    teamGroupHint: 'Where this person appears on the about page: the Board register, the Group CEO card, or the executive band.',
    teamRole: 'Role',
    teamRoleHint: 'Position or title, e.g. Chairman, Board Member, Operations.',
    teamMeta: 'Meta line',
    teamMetaHint: 'Optional tenure note shown under the Group CEO, e.g. Appointed Group CEO 2023.',
    teamBio: 'Biography',
    teamBioHint: 'Shown for the Board and the Group CEO. Separate paragraphs with a blank line.',
    teamPoints: 'Highlights',
    teamPointsHint: 'Short bullet points shown for executive-team members.',
    teamPhoto: 'Portrait',
    teamPhotoHint: 'Optional headshot. When empty the site shows a monogram of the initials.',
    teamEmail: 'Email',
    teamLinkedin: 'LinkedIn URL',
    copy: 'Copy',
    heroImage: 'Hero image',
    year: 'Year',
    categoryKey: 'Category',
    datasheet: 'Datasheet',
    coordinates: 'Coordinates',
    coordinatesHint: 'Click the map to drop the office pin, or type a latitude/longitude (e.g. from Google Maps). Used to place the office on the public KSA map.',
    latitude: 'Latitude',
    longitude: 'Longitude',
    links: 'Links',
    // Shared / structured doc fields
    icon: 'Icon',
    iconHint: 'Pick an on-brand house icon for this sector. Leave blank to use a custom image (below) or the bundled default.',
    customIcon: 'Custom icon',
    customIconHint: 'Optional. Upload an image to override the icon dropdown — a simple single-colour SVG matches the house icons best.',
    summary: 'Summary',
    description: 'Description',
    client: 'Client',
    confidential: 'Confidential',
    confidentialHint:
      'When on, the client name is hidden from the public website; the project still appears, marked Confidential.',
    location: 'Location',
    shortDescription: 'Short description',
    relatedProjects: 'Related projects',
    relatedProjectsHint: 'Projects shown alongside this industry on the public site.',
    project: 'Project',
    industryHint: 'Filters this project under an industry on the public site. Pick from your industries.',
    scope: 'Scope of work',
    outcome: 'Outcome',
    caseDiagram: 'Case diagram',
    caseDiagramHint: 'Optional single-line diagram for the featured case study.',
    flag: 'Editorial flag',
    flagHint: 'Optional badge shown on the article card.',
    readMinutes: 'Read time (minutes)',
    publishedAt: 'Published date',
    publishedAtHint: 'Displayed date, e.g. 2024-01-10. Distinct from the CMS publish action.',
    excerpt: 'Excerpt',
    deck: 'Deck',
    deckHint: 'The standfirst shown under the title on the card and article page.',
    topicTag: 'Topic tag',
    topicTagHint: 'Short label shown on the card, e.g. "Smart grid · Vision 2030".',
    author: 'Author',
    body: 'Body',
    mark: 'Mark / thumbnail',
    employmentType: 'Employment type',
    brief: 'Brief',
    experience: 'Experience',
    jobDescription: 'Description',
    overview: 'Overview',
    responsibilities: 'Responsibilities',
    requirements: 'Requirements',
    howToApply: 'How to apply',
    familyHint: 'The family this product belongs to. Sets the link the public site filters on.',
    tag: 'Tag',
    spec: 'Spec line',
    badge: 'Badge',
    badgeHint: 'Optional editorial mark on the product card (leave blank for none).',
    badgeLabel: 'Badge label',
    badgeTone: 'Badge tone',
    thumbnail: 'Thumbnail',
    thumbnailHint: 'Card image. Leave empty to keep the bundled illustration for a launch product.',
    specs: 'Specifications',
    specLabel: 'Spec label',
    specValue: 'Spec value',
    specUnit: 'Unit',
    variants: 'Variants / range',
    variantName: 'Name',
    variantSpec: 'Spec',
    variantNote: 'Note',
    highlights: 'Highlights',
    hero: 'Hero',
    heroHeadline: 'Headline',
    heroSupporting: 'Supporting text',
    stats: 'Key stats',
    statValue: 'Value',
    statSuffix: 'Unit / suffix',
    statLabel: 'Label',
    standardsHint: 'One standard per line, e.g. IEC 61439.',
    cta: 'Call to action',
    ctaHeading: 'Heading',
    ctaBody: 'Body',
    ctaPrimary: 'Primary button',
    ctaLabel: 'Button label',
    ctaHref: 'Button link',
    // ── Phase-3 sync: Pharadev services / case-studies / clients / team / testimonials ──
    updatedIso: 'Last-updated date',
    updatedIsoHint: 'Optional ISO date shown as "Updated" metadata, e.g. 2026-05-02.',
    shortTitle: 'Short title',
    shortTitleHint: 'Compact label used on the service card and homepage teaser.',
    serviceIconHint: 'Pick the Lucide glyph shown on this service card.',
    serviceTier: 'Tier',
    serviceTierHint: 'Core services are listed in full on /services and the home page; “Also available” ones render in a compact group. Their pages stay live either way.',
    features: 'Features',
    featuresHint: 'The scope checklist shown on the service detail page — one line each.',
    benefits: 'Benefits',
    benefitsHint: 'Metric tiles on the detail page: a display token plus a localized label.',
    metric: 'Metric',
    metricHint: 'A short display token, identical in every language, e.g. "80%" or "3x".',
    label: 'Label',
    faq: 'FAQ',
    faqQuestion: 'Question',
    faqAnswer: 'Answer',
    serviceHeroHint: 'Optional hero image for the service detail page.',
    builtFor: 'Built for',
    industryKey: 'Industry (filter key)',
    industryKeyHint: 'The canonical key the public portfolio filters on. The label above is display-only.',
    kindHint: 'Splits the portfolio into Pharadev products and client work — a public filter.',
    device: 'Device frame',
    deviceHint: 'The hero device frame used for the card thumbnail.',
    serviceSlugs: 'Related services',
    serviceSlugsHint: 'Services delivered on this project. Each links to a service by slug.',
    service: 'Service',
    tech: 'Tech stack',
    techHint: 'Technologies used, one per line.',
    caseFeaturedHint:
      'Featured studies fill the homepage hero carousel — the first 5 in Sort order, so featuring a 6th changes nothing there. Also badges the study on the portfolio index and picks the homepage highlight.',
    logo: 'Logo',
    thumbnailEn: 'Thumbnail (English)',
    thumbnailEnHint: 'Card image shown on the English portfolio index.',
    thumbnailAr: 'Thumbnail (Arabic)',
    thumbnailArHint: 'Card image shown on the Arabic portfolio index.',
    liveUrl: 'Live URL',
    liveUrlHint: 'Optional link to the live product or project.',
    gallery: 'Gallery',
    galleryHint: 'Screens shown on the case-study page, each with an optional caption.',
    galleryImage: 'Image',
    galleryCaption: 'Caption',
    caseStudySlugHint: 'Optionally link this entry to its portfolio case study.',
    teamNoteHint: 'Optional short line shown under the name, e.g. a focus area.',
    openHint: 'Marks an open hiring slot — the site shows a monogram instead of a portrait.',
    linkedin: 'LinkedIn URL',
    linkedinHint: 'Full profile URL, e.g. https://linkedin.com/in/name.',
  },
  families: {
    eyebrow: 'PRODUCT FAMILIES',
    title: 'Product families',
    newFamily: 'New family',
    createPermission: 'Requires permission to create or edit content.',
    editPermission: 'Requires permission to edit content.',
    colName: 'Name',
    colCatalog: 'Catalog',
    colOrder: 'Order',
    statusAll: 'All statuses',
    statusDraft: 'Draft',
    statusInReview: 'In review',
    statusScheduled: 'Scheduled',
    statusPublished: 'Published',
    statusArchived: 'Archived',
    catalogPreview: 'Preview',
    catalogReady: 'Ready',
    newTitle: 'New product family',
    untitled: '(untitled)',
    name: 'Name',
    shortName: 'Short name',
    tagline: 'Tagline',
    slugHint: 'Auto-generated from the English name; edit to override.',
    catalogStatus: 'Catalog status',
    sortOrder: 'Sort order',
    summary: 'Summary',
    description: 'Description',
    heroImage: 'Hero image',
    icon: 'Icon',
    schematic: 'Schematic',
    datasheet: 'Datasheet',
    industries: 'Industries',
    industriesHint: 'Industries this family serves. Used for the public industry filters and homepage grouping.',
    addIndustry: 'Add industry',
    remove: 'Remove',
    noIndustries: 'No industries linked yet.',
    docTitle: 'Marketing content',
    highlights: 'Highlights',
    applications: 'Applications',
    features: 'Features',
    standards: 'Standards',
    tabDetails: 'Details',
    tabProducts: 'Products',
    tabSeo: 'SEO',
    tabHistory: 'History',
    createdToast: 'Created.',
    savedToast: 'Saved.',
    publishedToast: 'Publication updated.',
    unpublishedToast: 'Unpublished.',
    unpublishRedirect: 'The public page now redirects to /products.',
    siteUpdateBody: 'The public site will update shortly.',
    deleteTitle: 'Delete this product family?',
    deleteDescription: 'The family will be permanently removed and its page will redirect to /products. This cannot be undone.',
    // Readiness gate (preview ⇄ ready)
    readinessHeading: 'Ready checklist',
    readinessReady: 'All set for ready',
    readinessMissing: '{{count}} still needed',
    readinessHint: 'A "ready" family needs all of these before it can be published, or its public page would render incomplete.',
    readyCard: 'Index card content',
    readyDetail: 'Detail page content',
    readyBlocked: "Can't set this family to ready yet.",
    readyBlockedDetail: 'Fill in the highlighted fields, then save again.',
    docSchemaError: 'Could not load the content schema. Refresh to try again.',
    // Products panel
    productsHeading: 'Products in this family',
    productsHint: 'Products that list under this family on the public site.',
    addProduct: '+ Add product',
    noProducts: 'No products yet. Add one to list it under this family.',
    // Delete cascade (block-and-warn)
    deleteBlockedTitle: "Can't delete: published products",
    deleteBlockedDescription: 'This family still has published products ({{slugs}}). Unpublish or move them first, then delete the family.',
  },
  pages: {
    eyebrow: 'PAGES',
    title: 'Pages',
    newPage: 'New page',
    untitled: '(untitled)',
    allStatuses: 'All statuses',
    statusDraft: 'Draft',
    statusScheduled: 'Scheduled',
    statusPublished: 'Published',
    statusArchived: 'Archived',
    slugHint: 'Auto-generated from the English title; edit to override.',
    keyHint: 'Unique internal key (e.g. home, about).',
    tabSections: 'Sections',
    tabDetails: 'Details',
    tabSeo: 'SEO',
    tabHistory: 'History',
    editPermissionRequired: 'Requires permission to edit content.',
    createdToast: 'Created.',
    savedToast: 'Saved.',
    publicationUpdatedToast: 'Publication updated.',
    unpublishedToast: 'Unpublished.',
    siteUpdateSoon: 'The public site will update shortly.',
    deletePageTitle: 'Delete this page',
    deletePageDescription: 'The page and all its sections will be removed. This cannot be undone.',
    deletePageConfirm: 'Delete page',
    sectionsCount: '{{count}} sections',
    addSection: 'Add section',
    addSectionTitle: 'Add a section',
    addSectionDescription: "Choose a block type. The form is generated from the block's schema.",
    deleteSectionTitle: 'Delete this section',
    deleteSectionDescription: 'The section will be removed from the page. This cannot be undone.',
    sectionDeletedToast: 'Section deleted.',
    sectionAddedToast: 'Section added.',
    sectionSavedToast: 'Section saved.',
    pageUpdateSoon: 'The public page will update shortly.',
    noSectionsYet: 'No sections yet',
    noSectionsHint: 'Use "Add section" above to place the first block on this page.',
    dragToReorder: 'Drag to reorder',
    visible: 'Visible',
    hidden: 'Hidden',
    loadingBlockTypes: 'Loading block types…',
    noBlockTypes: 'No block types are registered.',
    addBlockTitle: 'Add {{name}}',
    editBlockTitle: 'Edit {{name}}',
    anchor: 'Anchor',
    anchorHint: 'Optional HTML anchor for deep-linking (e.g. hero → #hero).',
    visibleOnPublicPage: 'Visible on the public page',
    // Friendly, localized block-type display names (keyed by the raw schema key). A humanized
    // fallback covers any block type the backend adds before this catalog is updated.
    blockNames: {
      hero: 'Hero',
      rich_text: 'Rich text',
      cta: 'Call to action',
      faq: 'FAQ',
      feature_grid: 'Feature grid',
      stats: 'Statistics',
      html_embed: 'HTML embed',
      articles_showcase: 'Articles showcase',
      certifications: 'Certifications',
      contact_form: 'Contact form',
      department_contacts: 'Department contacts',
      downloads: 'Downloads',
      gallery: 'Gallery',
      industries_showcase: 'Industries showcase',
      jobs_list: 'Jobs list',
      locations: 'Locations',
      logos: 'Logos',
      map: 'Map',
      process: 'Process',
      product_family_showcase: 'Product family showcase',
      product_showcase: 'Product showcase',
      projects_showcase: 'Projects showcase',
      proof: 'Proof points',
      quote_form: 'Quote form',
      services: 'Services',
      split_media: 'Split media',
      steps: 'Steps',
      subsidiaries: 'Subsidiaries',
      team_grid: 'Team grid',
      testimonials: 'Testimonials',
    },
    blockDescriptions: {
      hero: "The page's lead banner with heading and call-to-action.",
      rich_text: 'A heading with formatted body copy.',
      cta: 'A prompt with heading, body, and buttons.',
      faq: 'A list of frequently asked questions.',
      feature_grid: 'A grid of features or highlights.',
      stats: 'A row of key figures.',
      html_embed: 'A raw HTML or embed snippet.',
      articles_showcase: 'A curated strip of insight articles.',
      certifications: 'Accreditation and standards badges.',
      contact_form: 'An inline contact / inquiry form.',
      department_contacts: 'Per-department routing details.',
      downloads: 'Downloadable files and datasheets.',
      gallery: 'An image gallery.',
      industries_showcase: 'Featured industries served.',
      jobs_list: 'A listing of open positions.',
      locations: 'Office or site locations.',
      logos: 'Partner or client logos.',
      map: 'An embedded location map.',
      process: 'A step-by-step process.',
      product_family_showcase: 'Featured product families.',
      product_showcase: 'Featured products.',
      projects_showcase: 'Featured projects.',
      proof: 'Key stats and credibility markers.',
      quote_form: 'A request-for-quote form.',
      services: 'A services overview.',
      split_media: 'Text alongside an image or video.',
      steps: 'An ordered list of steps.',
      subsidiaries: 'Group subsidiaries.',
      team_grid: 'Team member profiles.',
      testimonials: 'Customer testimonials.',
    },
  },
  leads: {
    unknownType: 'Unknown lead type.',
    allStatuses: 'All statuses',
    allAssignees: 'All assignees',
    assignee: 'Assignee',
    assignedToLabel: 'Assigned to',
    assignedTo: 'Assigned to {{name}}',
    createdAt: 'Created {{date}}',
    from: 'From',
    to: 'To',
    newOnly: 'New only',
    spam: 'Spam',
    showingSpam: 'Showing spam-classified records.',
    exportCsv: 'Export CSV',
    exportTruncatedTitle: 'Results truncated, refine filters.',
    exportTruncatedBody: 'Export is capped at {{count}} rows.',
    readPermissionReason: 'Requires permission to read leads.',
    managePermissionReason: 'Requires permission to manage leads.',
    confirmedPage: 'Confirmed (page) {{count}}',
    pendingPage: 'Pending (page) {{count}}',
    colName: 'Name',
    colEmail: 'Email',
    colCompany: 'Company',
    colLocale: 'Locale',
    colRequest: 'Request',
    estimate: {
      heading: 'Estimate from /pricing',
      package: 'Package',
      from: 'from',
      care: 'Monthly care plan',
      perMonth: 'per month',
      custom: 'Scope past the package maximum',
      pages_one: '{{count}} page',
      pages_other: '{{count}} pages',
      bilingual: 'Arabic + English',
      integrations_one: '{{count}} integration',
      integrations_other: '{{count}} integrations',
      unpriced: {
        unknown_package: 'Not priced: package no longer published',
        unavailable: 'Not priced: price card unavailable',
      },
      line: {
        base: 'Package base',
        pages: 'Extra pages',
        bilingual: 'Second language',
        integration: 'Integrations',
        mobile_app: 'Mobile app',
        inherited_code: 'Code another team wrote',
        live_replacement: 'Replacing a live site',
      },
    },
    source: {
      heading: 'Source',
      label: 'Source',
      all: 'All sources',
      pageNote: 'Source filter applies to this page: {{shown}} of {{total}} shown.',
      channel: {
        linkedin: 'LinkedIn',
        google: 'Google',
        meta: 'Meta',
        chatgpt: 'ChatGPT',
        direct: 'Direct',
        referral: 'Referral',
      },
      filter: {
        linkedin: 'LinkedIn',
        google: 'Google',
        meta: 'Meta',
        chatgpt: 'ChatGPT',
        direct: 'Direct',
        referral: 'Referral sites',
        other: 'Other campaigns',
        none: 'Not recorded',
      },
      fields: {
        utmSource: 'UTM source',
        utmMedium: 'UTM medium',
        utmCampaign: 'UTM campaign',
        utmContent: 'UTM content',
        utmTerm: 'UTM term',
        liFatId: 'LinkedIn click id',
        gclid: 'Google click id',
        fbclid: 'Meta click id',
        landingPath: 'Landing page',
        referrer: 'Referrer',
        userAgent: 'User agent',
      },
    },
    kind: {
      label: 'Type',
      all: 'Calls and messages',
      call: 'Call',
      message: 'Message',
    },
    call: {
      heading: 'Call request',
      channel: { whatsapp: 'WhatsApp', video: 'Video call', phone: 'Phone call' },
      openWhatsApp: 'Open WhatsApp chat',
      dial: 'Call now',
      noWindows: 'No preferred times were recorded.',
      visitorTime: '({{time}} visitor time)',
      zoneNote: 'Preferred windows in order, {{zone}} time. Reply to confirm one.',
      visitorZone: 'Visitor is in {{zone}}.',
    },
    colCv: 'CV',
    cvYes: 'CV ✓',
    cvNo: 'No CV',
    leadDetail: 'Lead detail',
    leadUpdated: 'Lead updated.',
    recordErased: 'Record permanently erased.',
    unassigned: 'Unassigned',
    yes: 'Yes',
    no: 'No',
    attachment: 'Attachment',
    file: 'File',
    metadataOnly: 'Metadata only. No inline download in this version.',
    manage: 'Manage',
    internalNotes: 'Internal notes',
    notesReplaceHint: 'Saving replaces the existing notes.',
    saveChanges: 'Save changes',
    dangerZone: 'Danger zone',
    erasureDescription:
      'PDPL erasure permanently deletes this record and all of its personal data. This is irreversible and distinct from the archived or spam workflow statuses.',
    erasePermanently: 'Erase permanently',
    confirmEraseTitle: 'Permanently erase this record?',
    confirmEraseDescription:
      'This hard-deletes the record and its PII (PDPL erasure). It cannot be undone.',
    cv: 'CV',
    cvRestricted: 'Restricted asset. A fresh download link is generated each time.',
    openCv: 'Open CV',
    noCvUrl: 'No download URL is available for this CV.',
    fields: {
      fullName: 'Name',
      email: 'Email',
      phone: 'Phone',
      company: 'Company',
      inquiryType: 'Inquiry type',
      subject: 'Subject',
      country: 'Country',
      region: 'Region',
      industry: 'Industry',
      projectLocation: 'Project location',
      budget: 'Budget',
      productFamily: 'Product family',
      application: 'Application',
      routedTo: 'Routed to',
      message: 'Message',
      pdplConsent: 'PDPL consent',
      productId: 'Product id',
      familyId: 'Family id',
      quantity: 'Quantity',
      requirements: 'Requirements',
      consent: 'Consent',
      jobPostingId: 'Job posting id',
      portfolio: 'Portfolio',
      linkedin: 'LinkedIn',
      coverLetter: 'Cover letter',
      status: 'Status',
      confirmedAt: 'Confirmed at',
      unsubscribedAt: 'Unsubscribed at',
      locale: 'Locale',
    },
  },
  leadStatus: {
    new: 'New',
    in_progress: 'In progress',
    reviewing: 'Reviewing',
    shortlisted: 'Shortlisted',
    responded: 'Responded',
    hired: 'Hired',
    rejected: 'Rejected',
    closed: 'Closed',
    spam: 'Spam',
    archived: 'Archived',
    pending_confirmation: 'Pending confirmation',
    confirmed: 'Confirmed',
    unsubscribed: 'Unsubscribed',
  },
  media: {
    eyebrow: 'MEDIA',
    libraryTitle: 'Media library',
    kind: 'Kind',
    kindAll: 'All kinds',
    kindImages: 'Images',
    kindSvg: 'SVG',
    kindPdf: 'PDF',
    kindDocuments: 'Documents',
    kindVideo: 'Video',
    searchPlaceholder: 'File name, alt, tags…',
    size: 'Size',
    dimensions: 'Dimensions',
    uploaded: 'Uploaded',
    checksum: 'Checksum',
    altText: 'Alt text',
    caption: 'Caption',
    credit: 'Credit',
    folder: 'Folder',
    tagsLabel: 'Tags (comma-separated)',
    restrictedAsset: 'Restricted asset',
    restrictedHint:
      'Restricted assets use short-lived presigned URLs and are never cached.',
    tabDetails: 'Details',
    tabUsages: 'Usages',
    cannotDeleteInUse: 'Cannot delete: this asset is still in use.',
    removeOrSwapRefs: 'Remove or swap these references, then try again.',
    deleteAssetTitle: 'Delete media asset',
    deleteAssetDescription:
      'Deletion is blocked if the asset is referenced anywhere. Any blocking references will be listed.',
    notReferencedSafe: 'This asset is not referenced anywhere. Safe to delete.',
    savedToast: 'Saved.',
    deletedToast: 'Deleted.',
    chooseMedia: 'Choose media',
    uploadedToast: 'Uploaded.',
    uploadedToastDetail: 'The asset is ready to use.',
    unsupportedType: 'Unsupported file type: .{{ext}}',
    exceedsLimit: 'File exceeds the {{limit}} limit.',
    unsafeSvgTitle: 'This SVG could not be safely cleaned.',
    unsafeSvgDetail: 'It contains active content (scripts or event handlers) that cannot be removed. Re-export it as a plain vector or use a PNG.',
    dragFileHere: 'Drag a file here, or',
    chooseFile: 'Choose file',
    acceptedHint: 'Images, SVG, PDF, DOC, video · max {{limit}}',
    altTextEnglish: 'Alt text (English)',
    altTextRequiredHint: 'Required before an image can be referenced.',
    upload: 'Upload',
  },
  settings: {
    eyebrow: 'SETTINGS',
    pageTitle: 'Site settings and chrome',
    forbidden: 'Site settings are managed by administrators.',
    nav: {
      settings: 'Settings',
      strings: 'UI strings',
      navigation: 'Navigation',
      redirects: 'Redirects',
      directory: 'Contact directory',
      countries: 'Countries',
      pageCopy: 'Page copy',
    },
    general: {
      savedTitle: 'Settings saved.',
      savedDetail: 'The public site will update shortly.',
      localesHeading: 'Locales',
      defaultLocale: 'Default locale',
      enabledLocales: 'Enabled locales',
      localeEn: 'English (en)',
      localeAr: 'Arabic (ar)',
      requireAr: 'Require Arabic on publish',
      requireArHint: 'Block publishing content that is missing its Arabic translation.',
      maintenanceHeading: 'Maintenance mode',
      maintenanceToggle: 'Put the public site in maintenance mode',
      maintenanceHint:
        'Replaces every public page with a friendly “under maintenance” notice so visitors never see unfinished or placeholder content. Editors keep working in the console; the change takes effect within a minute.',
      brandIdentityHeading: 'Brand identity',
      brandIdentityDescription:
        'The wordmark, tagline and canonical URL the public site renders in its chrome.',
      wordmark: 'Wordmark',
      wordmarkHint: 'The site wordmark, e.g. Pharadev.',
      wordmarkAr: 'Wordmark (Arabic)',
      wordmarkArHint: 'The Arabic-script wordmark shown on /ar.',
      tagline: 'Tagline',
      taglineHint: 'The short line under the wordmark — the human margin voice.',
      siteUrl: 'Site URL',
      siteUrlHint: 'Canonical public URL, e.g. https://pharadev.com.',
      brandHeading: 'Brand assets',
      brandDescription:
        'Media asset ids for the public site chrome. Leave blank to use the theme default.',
      logoAssetId: 'Logo asset id',
      faviconAssetId: 'Favicon asset id',
      ogImageAssetId: 'Default share image asset id',
      headScriptsHeading: 'Head scripts',
      headScriptsWarning:
        'Caution: this markup is injected verbatim into the head of every public page. Invalid or malicious code can break or compromise the live site. Only paste trusted analytics or verification snippets.',
      headScriptsLabel: 'Markup injected into the public site head',
      saveButton: 'Save settings',
    },
    messaging: {
      heading: 'Messaging channels',
      description:
        'Chat apps the public site offers next to WhatsApp (homepage hero and /contact). The WhatsApp number is the secondary phone in the contact directory.',
      telegram: 'Telegram username',
      telegramHint:
        'The handle visitors message, e.g. pharadev for t.me/pharadev. Pasting @pharadev or the t.me link also works. Leave blank to hide Telegram.',
      telegramInvalid:
        'Use a Telegram username: 5–32 letters, digits or underscores, starting with a letter.',
    },
    social: {
      heading: 'Social links',
      description:
        'Profiles linked from the site footer and listed as the organization’s profiles for search engines. One link per platform.',
      platform: 'Platform',
      url: 'Profile URL',
      urlPlaceholder: 'https://www.linkedin.com/company/…',
      add: 'Add social link',
      remove: 'Remove link {{n}}',
      moveUp: 'Move link {{n}} up',
      moveDown: 'Move link {{n}} down',
      rowLabel: 'Social link {{n}}',
      empty: 'No social links yet. The footer shows none until you add one.',
      errPlatformRequired: 'Choose a platform.',
      errPlatformDuplicate: 'This platform is already listed. Keep one link per platform.',
      errUrlRequired: 'Enter the profile URL.',
      errUrlInvalid: 'Enter a full URL, e.g. https://www.linkedin.com/company/pharadev.',
      errUrlHttps: 'Use a secure https:// URL.',
      fixErrors: 'Fix the highlighted social links before saving.',
      platforms: {
        linkedin: 'LinkedIn',
        x: 'X (Twitter)',
        facebook: 'Facebook',
        instagram: 'Instagram',
        youtube: 'YouTube',
        github: 'GitHub',
        tiktok: 'TikTok',
      },
    },
    navigation: {
      menuHeader: 'Header',
      menuFooter: 'Footer',
      menuMobile: 'Mobile',
      menuLegal: 'Legal',
      linkInternal: 'Internal (slug)',
      linkExternal: 'External (url)',
      savedTitle: 'Navigation saved.',
      savedDetail: 'The public site will update shortly.',
      itemDeleted: 'Item deleted.',
      errLabelRequired: 'English label is required.',
      errSlugRequired: 'Target slug is required for internal links.',
      errUrlRequired: 'URL is required for external links.',
      menuLabel: 'Menu',
      newItem: 'New item',
      deleteChildrenNote: 'Deleting an item also removes any of its child items.',
      moveUp: 'Move up',
      moveDown: 'Move down',
      untitled: '(untitled)',
      childTag: 'child',
      hiddenTag: 'Hidden',
      editItem: 'Edit nav item',
      newItemTitle: 'New nav item',
      fieldLabel: 'Label',
      linkType: 'Link type',
      targetSlug: 'Target slug',
      targetSlugHint: 'Path on the public site, e.g. /about.',
      url: 'URL',
      urlHint: 'Full external URL, e.g. https://example.com.',
      openInNewTab: 'Open in new tab',
      visible: 'Visible',
      deleteTitle: 'Delete nav item?',
      deleteDescription: 'This also removes any child items underneath it.',
    },
    contact: {
      savedTitle: 'Contact saved.',
      savedDetail: 'The public site will update shortly.',
      deleted: 'Contact deleted.',
      errKeyRequired: 'Key is required.',
      errLabelRequired: 'English label is required.',
      errEmailRequired: 'Email is required.',
      colLabel: 'Label',
      colEmail: 'Email',
      colPhone: 'Phone',
      colVisible: 'Visible',
      colOrder: 'Order',
      visibleTag: 'Visible',
      hiddenTag: 'Hidden',
      newContact: 'New contact',
      editContact: 'Edit contact',
      fieldLabel: 'Label',
      email: 'Email',
      phone: 'Phone',
      sla: 'SLA',
      slaHint: 'Response-time commitment shown to visitors, e.g. within 2 business days.',
      sortOrder: 'Sort order',
      visible: 'Visible',
      deleteTitle: 'Delete contact?',
      deleteDescription: 'Remove "{{key}}" from the directory.',
    },
    countries: {
      savedTitle: 'Country saved.',
      savedDetail: 'The public site will update shortly.',
      defaultUpdatedTitle: 'Default country updated.',
      deleted: 'Country deleted.',
      errCode: 'Use a 2-letter ISO country code.',
      colCode: 'Code',
      colDefault: 'Default',
      colOrder: 'Order',
      defaultTag: 'Default',
      setDefault: 'Set default',
      newCountry: 'New country',
      editCountry: 'Edit country',
      isoCode: 'ISO code',
      isoCodeHint: 'Two-letter ISO 3166-1 code, e.g. SA.',
      sortOrder: 'Sort order',
      setAsDefault: 'Set as default',
      setAsDefaultHint: 'Makes this the sole default country.',
      deleteTitle: 'Delete country?',
      deleteDescription: 'Remove "{{code}}" from the register.',
    },
    redirects: {
      status301: '301 moved permanently',
      status302: '302 found',
      status307: '307 temporary',
      status308: '308 permanent',
      savedTitle: 'Redirect saved.',
      savedDetail: 'The public site will update shortly.',
      deleted: 'Redirect deleted.',
      errFromPath: 'Source path must start with "/".',
      errToRequired: 'Target is required.',
      errToDiffer: 'Target must differ from the source.',
      errStatus: 'Choose a valid redirect status.',
      colFrom: 'From',
      colTo: 'To',
      colActive: 'Active',
      colHits: 'Hits',
      activeTag: 'Active',
      inactiveTag: 'Inactive',
      newRedirect: 'New redirect',
      editRedirect: 'Edit redirect',
      dialogDescription:
        'Upserts by source path. Editing the source path of an existing redirect creates a new entry.',
      fromPath: 'From path',
      fromPathHint: 'Must start with a forward slash, e.g. /old-page.',
      toPath: 'To path',
      toPathHint: 'Destination path or full URL.',
      active: 'Active',
      deleteTitle: 'Delete redirect?',
      deleteDescription: 'Remove the redirect from {{from}}.',
    },
    pageCopy: {
      savedTitle: 'Saved.',
      savedDetail: 'The public site will update shortly.',
      selectPrompt: 'Select a namespace to edit its copy.',
      searchPlaceholder: 'Filter namespaces…',
      updatedAt: 'Updated {{time}}',
      // Content editor
      notObject: 'The document must be a JSON object.',
      emptyGroup: 'No fields.',
      emptyList: 'No items.',
      itemLabel: 'Item {{index}}',
      booleanLabel: 'Enabled',
      emptyTextPlaceholder: 'Enter text…',
      unsaved: 'Unsaved changes',
      allSaved: 'All changes saved',
      // Arabic coverage
      arabicComplete: 'Arabic translation complete',
      arabicCompleteHintReady: 'Every field has Arabic copy.',
      arabicCompleteHintPending: '{{count}} field(s) still missing Arabic.',
      arCoverage: 'Arabic coverage',
      coverageCount: '{{translated}} / {{total}} translated',
      noFields: 'No translatable fields',
      // Usages (reverse index → consuming pages)
      usagesHeading: 'Appears on',
      usagesLoading: 'Checking where this copy appears…',
      usedByCount: '{{count}} page(s)',
      unused: 'Unused',
      unusedHint: 'No page references this namespace yet.',
      viaNamespaces: 'shared',
      viaCta: 'CTA',
    },
    strings: {
      savedTitle: 'String saved.',
      savedDetail: 'The public site will update shortly.',
      deleted: 'String deleted.',
      errNamespaceRequired: 'Namespace is required.',
      errKeyRequired: 'Key is required.',
      errValueRequired: 'English value is required.',
      colNamespace: 'Namespace',
      missingAr: 'Missing AR',
      newString: 'New string',
      editString: 'Edit string',
      namespace: 'Namespace',
      value: 'Value',
      deleteTitle: 'Delete string?',
      deleteDescription: 'Remove "{{id}}" from the site chrome.',
    },
  },
  users: {
    eyebrow: 'ADMINISTRATION',
    title: 'Users',
    newUser: 'New user',
    forbidden: 'You need permission to administer users to view this area.',
    sessionNote:
      'Resetting a password or deactivating a user revokes their active sessions immediately.',
    columns: {
      email: 'Email',
      name: 'Name',
      role: 'Role',
      locale: 'Locale',
      status: 'Status',
      lastLogin: 'Last login',
      mfa: 'MFA',
    },
    status: {
      active: 'Active',
      inactive: 'Inactive',
    },
    mfa: {
      enabled: 'MFA',
    },
    serviceAccount: 'Service account',
    serviceAccountNote:
      'This is a service account: a machine principal that owns an API token\u2019s role and audit trail. It has no password and cannot sign in. To change its access, revoke or re-issue its token under API tokens.',
    roles: {
      admin: 'Admin',
      editor: 'Editor',
      author: 'Author',
      translator: 'Translator',
      sales: 'Sales',
      viewer: 'Viewer',
    },
    locales: {
      en: 'English',
      ar: 'العربية',
    },
    fields: {
      email: 'Email',
      name: 'Name',
      role: 'Role',
      locale: 'Locale',
      active: 'Active',
      initialPassword: 'Initial password',
      resetPassword: 'Reset password',
      resetPasswordPlaceholder: 'Leave blank to keep current',
    },
    hints: {
      minChars: 'At least 10 characters.',
      deactivate: "Deactivating revokes this user's sessions.",
      resetPassword: "At least 10 characters. Resetting revokes this user's sessions.",
    },
    create: {
      title: 'New user',
      description:
        'Create an admin user. They can sign in with the initial password you set here.',
      submit: 'Create user',
    },
    edit: {
      title: 'Edit {{name}}',
      save: 'Save changes',
    },
    delete: {
      title: 'Delete {{name}}?',
      description:
        'This soft-deletes {{email}} and revokes their active sessions. The server blocks deleting the last active administrator. This cannot be undone from here.',
      confirm: 'Delete user',
    },
    toasts: {
      created: 'User {{email}} created.',
      updated: 'User {{email}} updated.',
      deleted: 'User {{email}} deleted. Their sessions were revoked.',
    },
    errors: {
      emailInUse: 'That email address is already in use.',
      lastAdmin: 'Cannot demote or disable the last active administrator.',
    },
  },
  apiTokens: {
    eyebrow: 'ADMINISTRATION',
    title: 'API tokens',
    newToken: 'New token',
    forbidden: 'You need permission to administer users to manage API tokens.',
    intro:
      'API tokens let a machine client — the LLM connector, or a CI job — write to the CMS through the same permissions, validation and audit trail a person uses. Each token belongs to a service account, can be narrowed further, and can be revoked instantly.',
    allCollections: 'All collections',
    neverExpires: 'Never expires',
    neverUsed: 'Never used',
    columns: {
      name: 'Token',
      account: 'Service account',
      grants: 'Can do',
      collections: 'Can write to',
      lastUsed: 'Last used',
      expires: 'Expires',
      status: 'Status',
    },
    status: {
      active: 'Active',
      expired: 'Expired',
      revoked: 'Revoked',
    },
    empty: {
      eyebrow: 'NO TOKENS YET',
      title: 'Give an agent a way in, safely',
      description:
        'A connector token lets an AI agent add portfolio projects, upload images and write Arabic copy — as a named principal you can watch and switch off. It is not a shared password: it belongs to a service account that can never sign in to this console.',
      point1: 'Everything the agent creates is a draft. Publishing stays a human decision.',
      point2: 'Every write appears in the audit log against the account and the specific token.',
      point3: 'Revoking a token takes effect on the very next request.',
    },
    fields: {
      name: 'Token name',
      namePlaceholder: 'Claude — portfolio agent (laptop)',
      account: 'Service account',
      newAccount: 'Create a new service account',
      accountName: 'Account name',
      accountNamePlaceholder: 'Portfolio agent',
      role: 'Role',
      scopes: 'Permissions',
      collections: 'Collections it may write to',
      expiry: 'Expires after',
    },
    hints: {
      name: 'Name it after where it runs, so you know which one to revoke.',
      role: 'The permission ceiling. Author can write, translate and upload media, but cannot publish or delete.',
      scopes:
        'Optional. Selecting nothing grants everything the role allows; selecting some narrows it further. A token can never hold more than its role.',
      scopesEmpty: 'Nothing selected: this token gets everything the role allows.',
      collections:
        'Optional. Selecting nothing lets it write to every collection. Reads are not restricted, so the agent can still resolve links between collections.',
      collectionsEmpty: 'Nothing selected: this token can write to every collection.',
      neverExpiresWarning:
        'A token that never expires has to be revoked by hand. Prefer a dated one and rotate it.',
    },
    expiry: {
      days: '{{count}} days',
      never: 'Never (not recommended)',
    },
    create: {
      title: 'New API token',
      description:
        'The secret is shown once, immediately after creation, and cannot be recovered afterwards.',
      submit: 'Create token',
    },
    secret: {
      title: 'Copy this token now',
      description: 'This is the only time the secret for "{{name}}" is shown.',
      warning:
        'The secret is stored hashed and cannot be recovered. If you close this without copying it, you will have to create a new token.',
      secretLabel: 'Token secret',
      setupLabel: 'Register the connector',
      setupHelp:
        'Run this on the machine that will host the connector, replacing the two paths with your own.',
      gitWarning: 'Do not commit this command or the resulting config: it contains a live credential.',
      copySecret: 'Copy token secret',
      copyCommand: 'Copy setup command',
      copied: 'Copied',
      done: 'I have copied it',
      confirmClose: {
        title: 'Close without copying the secret?',
        description:
          'You have not copied anything yet. The secret cannot be shown again, and the token will be unusable.',
        confirm: 'Close anyway',
      },
    },
    revoke: {
      action: 'Revoke',
      title: 'Revoke {{name}}?',
      description:
        'The next request made with this token fails immediately. Anything it already wrote stays, and stays attributed to it in the audit log. This cannot be undone — issue a new token instead.',
      confirm: 'Revoke token',
    },
    toasts: {
      revoked: 'Token {{name}} revoked.',
    },
  },
  audit: {
    eyebrow: 'AUDIT',
    title: 'Audit log',
    forbidden: 'You do not have permission to view the audit log.',
    colTime: 'Time',
    colActor: 'Actor',
    colAction: 'Action',
    colEntity: 'Entity',
    colIp: 'IP',
    filterEntityType: 'Entity type',
    filterEntityId: 'Entity ID',
    filterActorId: 'Actor ID',
    filterApiTokenId: 'API token ID',
    filterApiTokenHint: 'Narrow to one credential, not just the account behind it.',
    viaToken: 'via token',
    filterFrom: 'From',
    filterTo: 'To',
    entryTitle: 'Audit entry',
    detailUserAgent: 'User agent',
    detailDiff: 'Diff',
  },
  account: {
    eyebrow: 'Account',
    title: 'Your account',
    profile: 'Profile',
    name: 'Name',
    interfaceLanguage: 'Interface language',
    saveProfile: 'Save profile',
    changePassword: 'Change password',
    currentPassword: 'Current password',
    newPassword: 'New password',
    profileUpdated: 'Profile updated.',
    passwordChanged: 'Password changed. Your other sessions were signed out.',
    mfaTitle: 'Two-factor authentication',
    mfaEnabledHint: 'MFA is enabled. Sign-in requires a code from your authenticator app.',
    mfaSetupHint: 'Add a time-based one-time code (TOTP) for an extra layer of security.',
    beginEnrollment: 'Begin enrollment',
    qrAlt: 'MFA QR code',
    enterSecret: 'Or enter this secret: {{secret}}',
    code6: '6-digit code',
    code6Disable: '6-digit code to disable',
    verifyAndEnable: 'Verify and enable',
    disableMfa: 'Disable MFA',
    mfaEnabledToast: 'Two-factor authentication enabled.',
    mfaDisabledToast: 'Two-factor authentication disabled.',
    mfaBadge: 'MFA',
    strengthTooWeak: 'Too weak',
    strengthWeak: 'Weak',
    strengthFair: 'Fair',
    strengthGood: 'Good',
    strengthStrong: 'Strong',
  },
  search: {
    placeholder: 'Search content & site copy…',
    ariaLabel: 'Global search',
    searching: 'Searching…',
    noResults: 'No results.',
    entity: {
      page: 'Page',
      page_copy: 'Page copy',
      family: 'Family',
      product_family: 'Family',
      industry: 'Industry',
      project: 'Project',
      article: 'Article',
      job: 'Job',
      product: 'Product',
      location: 'Location',
      subsidiary: 'Subsidiary',
    },
  },
  preview: {
    dialogTitle: 'Draft preview',
    iframeTitle: 'Preview',
  },
  revisions: {
    restore: 'Restore',
    restoredToast: 'Restored as a new revision.',
    restoredToastDesc: 'Publication status was left unchanged.',
    restoreDialogTitle: 'Restore content as a new revision',
    restoreDialogDesc:
      "This re-applies the selected revision's editorial fields and creates a new revision. Publication status is left unchanged.",
  },
  publish: {
    publishNow: 'Publish now',
    reschedule: 'Reschedule',
    scheduleDialogTitle: 'Schedule publication',
    scheduleDialogDesc: 'The backend ticker publishes at the chosen time.',
    publishAt: 'Publish at',
  },
  seo: {
    metaTitle: 'Meta title',
    metaDescription: 'Meta description',
    keywords: 'Keywords',
    socialImage: 'Social image',
    canonicalUrl: 'Canonical URL',
    noIndex: 'Hide from search engines (noindex)',
  },
};

export default en;
export type ChromeStrings = typeof en;
